import apiFetch from '../apiFetch'

export default function (token, userRepairshopId) {
  return apiFetch({ endPoint: `RepairShop/Users/${userRepairshopId}`, method: 'DELETE', body: null, token: token })
}
